import React, { createContext, useContext, useMemo } from 'react';

import { useRemoteOverrides } from './RemoteOverridesProvider';
import { getEnvConfig } from '../envs/envConfig';
import type { Remote } from '../envs/types';

type RemotesMap = Map<string, Remote>;

const RemotesContext = createContext<RemotesMap>(new Map());

export function RemotesProvider({ children }: { children: React.ReactNode }) {
  const overrides = useRemoteOverrides();
  const remotes = useMemo(() => {
    const { remotes } = getEnvConfig();

    const remotesUrlMap = remotes.reduce((accumulator, remote) => {
      const { scope } = remote;
      const url = overrides[scope] ?? remote.url;

      return accumulator.set(scope, { ...remote, url });
    }, new Map() as RemotesMap);

    return remotesUrlMap;
  }, [overrides]);

  return (
    <RemotesContext.Provider value={remotes}>
      {children}
    </RemotesContext.Provider>
  );
}

export function useRemotes() {
  return useContext(RemotesContext);
}

export function useRemote(scope: string): Remote | undefined {
  const remotes = useRemotes();

  return remotes.get(scope);
}
